import { toast } from 'react-toastify';
import { NotificationMessage } from '../components/errorMessage/NotificationMessage';
import { iframeService } from './IframeService';
import { getTranslation, translationKeys } from '../core/translation/translation';
import { notificationStatus } from '../core/constats';

export const MESSAGE_TYPES = {
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_SPIN: 'INVALID_SPIN',
  MONEY_TRANSACTION_ERROR: 'MONEY_TRANSACTION_ERROR',
  NOT_ENOUGH_MONEY: 'NOT_ENOUGH_MONEY',
  INVALID_OPERATION: 'INVALID_OPERATION',
  SPIN_NOTFOUND: 'SPIN_NOTFOUND',
  INVALID_SPIN_COUNT: 'INVALID_SPIN_COUNT',
  INVALID_AMOUNT: 'INVALID_AMOUNT',
  YOUR_BET_IS_ACCEPTED: 'YOUR_BET_IS_ACCEPTED',
  PlayerLimitExceeded: 'PlayerLimitExceeded',
};

class NotificationHandler {
  constructor() {
    this._registeredHandlers = {};
  }

  handleError(error) {
    if (this._registeredHandlers[error?.errorMessage]) {
      return this._registeredHandlers[error?.errorMessage](error);
    } else {
      toast.error('Request Error');
      console.error(error);
    }
  }

  register(messageType, handler) {
    this._registeredHandlers[MESSAGE_TYPES[messageType]] = handler;
  }

  notEnoughMoney() {
    toast.error(<NotificationMessage message={getTranslation(translationKeys.NOT_ENOUGH_MONEY)}/>);
  }

  yourBetIsAccepted() {
    toast.success(<NotificationMessage message={getTranslation(translationKeys.YOUR_BET_IS_ACCEPTED)} type = {notificationStatus.Success}/>);
  }
}

const notificationHandler = new NotificationHandler(MESSAGE_TYPES);

notificationHandler.register(MESSAGE_TYPES.INVALID_AMOUNT, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.INVALID_AMOUNT)}/>);
});
notificationHandler.register(MESSAGE_TYPES.INVALID_SPIN, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.INVALID_SPIN)}/>);
});
notificationHandler.register(MESSAGE_TYPES.NOT_ENOUGH_MONEY, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.NOT_ENOUGH_MONEY)} />);
});
notificationHandler.register(MESSAGE_TYPES.MONEY_TRANSACTION_ERROR, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.MONEY_TRANSACTION_ERROR)}/>);
});
notificationHandler.register(MESSAGE_TYPES.SPIN_NOTFOUND, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.SPIN_NOTFOUND)}/>);
});
notificationHandler.register(MESSAGE_TYPES.INVALID_SPIN_COUNT, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.INVALID_SPIN_COUNT)}/>);
  iframeService.logout();
});
notificationHandler.register(MESSAGE_TYPES.INVALID_OPERATION, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.INVALID_OPERATION)}/>);
});
notificationHandler.register(MESSAGE_TYPES.PlayerLimitExceeded, () => {
  toast.error(<NotificationMessage message={getTranslation(translationKeys.LIMIT_EXCEEDED)}/>);
});


notificationHandler.register(MESSAGE_TYPES.INVALID_TOKEN, () => {
  if (iframeService.isInIframe()) {
    iframeService.reloadFrame();
  } else {
    window.location.reload();
  }
});


export {
  notificationHandler,
};
